import type { Post } from '@/payload-types'
import { formatSlug } from '@/fields/slug/formatSlug'

export function getPostHref(post: Post, locale: 'en' | 'cs'): string {
  const slugValue = post.slug

  if (typeof slugValue === 'string' && slugValue.length > 0) {
    return `/blog/${encodeURIComponent(slugValue)}`
  } else if (typeof slugValue === 'object' && slugValue !== null) {
    const localizedSlug = (slugValue as any)[locale]
    if (typeof localizedSlug === 'string' && localizedSlug.length > 0) {
      return `/blog/${encodeURIComponent(localizedSlug)}`
    }
  }

  if (post.title && typeof post.title === 'string') {
    const generatedSlug = formatSlug(post.title)
    return `/blog/${encodeURIComponent(generatedSlug)}`
  }

  return '/blog/'
}
